import { render, staticRenderFns } from "./ChurchModalComponent.vue?vue&type=template&id=5089042e&scoped=true&"
import script from "./ChurchModalComponent.vue?vue&type=script&lang=js&"
export * from "./ChurchModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5089042e",
  null
  
)

export default component.exports